
import { notification } from 'antd';

import style from './Notification.module.scss';


export const showNotification = ({ type, title,
  description, placement = 'radius-bottomright',
  duration = 10
}) => {
  // destory the previus notification
  notification.destroy();

  notification[type]({
    message: title,
    description,
    placement,
    duration,
    className: style.notification
  });
};
